import { useAPIStore } from "@/stores/APIStore"
import GP from "./gp"
import { computed } from "vue"
import { storeToRefs } from "pinia"



export default {
    moduleKey: "locations",
    enabledKey: "locations_enabled",
    userPermissions: [["@pollux.view.location.overview"]],
    async toggleFn(value, toast) {
        const APIStore = useAPIStore()
        return await APIStore.setLocationGranularPermissions(value, toast)
    },
    async getFn() {
        const APIStore = useAPIStore()
        return await APIStore.getLocationGranularPermissions()
    },
    async putFn(payload, toast) {
        const APIStore = useAPIStore()
        return await APIStore.putLocationGranularPermissions(payload, toast)
    },
    format: (roles, action) => ({ locationTypes = null, locationBranches = null, countries = null }) => {
        return [
            GP.rarg(action, (arg) => arg, "Unknown permissions", true, true),
            GP.rarg(roles, (arg) => `for ${arg} users`, "for an unknown group of users", true, true),
            GP.rarg(locationTypes, (arg) => `on all locations of type ${arg}`, 'on all locations'),
            GP.rarg(locationBranches, (arg) => `of ${arg}`),
            GP.rarg(countries, (arg) => `in ${arg}`)
        ].join(" ")
    },
    options: [
        {
            name: "locationTypes",
            ruleKey: "location_type",
            displayName: "Location Type",
            contextKey: "type",
            async fn() {
                const APIStore = useAPIStore()
                return await APIStore.getLocationTypes(true, true)
            },
            fnDisplayValue: "name",
            resolveValue: (c) => c.type?.id || c.type,
            ctxDisplayValue: (c) => c.type?.name || c.type
        },
        {
            name: "locationBranches",
            ruleKey: "location_branch",
            displayName: "Location Branch",
            contextKey: "branch",
            async fn() {
                const APIStore = useAPIStore()
                return await APIStore.getLocationBranches(false, true)
            },
            fnDisplayValue: "name",
            resolveValue: (c) => c.branch?.id || c.branch,
            ctxDisplayValue: (c) => c.branch?.name || c.branch
        },
        {
            name: "countries",
            ruleKey: "location_country",
            displayName: "Country",
            contextKey: "country",
            async fn() {
                const APIStore = useAPIStore()
                return await APIStore.getAllCountries()
            },
            fnDisplayValue: "name",
            resolveValue: (c) => c.country_id || c.country?.id || c.country_code || c.country?.code || c.country,
            ctxDisplayValue: (c) => c.country?.name || c.country_code || c.country?.code || c.country
        }
    ]
}
